import { createOptionalContext } from '../../../utils/hooks/create-optional-context.mjs';

const [InputWrapperProvider, useInputWrapperContext] = createOptionalContext({
  describedBy: void 0,
  inputId: void 0,
  labelId: void 0,
  ariaLabel: void 0
});

export { InputWrapperProvider, useInputWrapperContext };
